import React, { useEffect, useState, useContext } from 'react'
import { AuthContext } from '../AuthContext'
import { Col, Row, Container } from 'react-bootstrap'

import PowerFans from '../Power/PowerFans'
import Interaction from '../Power/Interaction'
import PowerScan from '../Power/PowerScan'
import AITeacher from '../AITeacher'
import Radar from '../Power/Radar'
import TrendTracking from '../Power/TrendTracking'
import { Helmet } from 'react-helmet'
import { useAPI } from '../../hooks/useAPI'

// import 'chart.js/auto'
// import { Doughnut } from 'react-chartjs-2'
import ReactEcharts from 'echarts-for-react'
// import { v4 as uuidv4 } from 'uuid'
import GroupSideBar from '../GroupSideBar'
import GroupPowerFans from './GroupPowerFans'
import GroupComprehensive from './GroupComprehensive'
import axios from 'axios'
import * as dayjs from 'dayjs'

const GroupPower = () => {
  const { currentUser, BaseUrl, setIsLoading, brandArr } =
    useContext(AuthContext)

  const getIncLast = 'powerAnalysis/v1/GetIncLast'
  const getSubIncorporation = 'incorporation/v1/GetSubIncorporation'
  const getLast = 'powerAnalysis/v1/GetLast'

  const today = dayjs().format('YYYY-MM-DD')
  const [csvDate, setCsvDate] = useState(today)
  const [csvData, setCsvData] = useState({
    totallyPerformance: [],
    sumfocVal: [],
    avefocVal: [],
    emofocVal: [],
    newattVal: [],
    fanresVal: [],
  })

  const [incLastData, setIncLastData] = useState([
    {
      totally_performance: 0,
      emofoc_val: 0,
      count_fans: 0,
      kol_id: '',
      avefoc_val: 0,
      count_yt: 0,
      kol_name: '',
      sumfoc_val: 0,
      newatt_val: 0,
      fanres_val: 0,
      count_ig: 0,
      count_fb: 0,
    },
  ])
  const [companyName, setCompanyName] = useState([
    {
      inc_id: '',
      kol_id: '',
      kol_name: '',
      inc_name: '',
    },
  ])
  // 各公司
  const [currentCompanyId, setCurrentCompanyId] = useState(null)
  const [currentCompany, setCurrentCompany] = useState(null)
  const [currentCompanyData, setCurrentCompanyData] = useState({
    ai_teacher_comment: '',
    mean_like_yt: 0,
    mean_like_ig: 0,
    radar_fanres_val: 0,
    mean_comment_fb: 0,
    radar_sumfoc_val: 0,
    radar_emofoc_val: 0,
    mean_share_yt: 0,
    mean_touch_fb: 0,
    count_yt: 0,
    sumfoc_val: 0,
    newatt_val: 0,
    fanres_val: 0,
    count_ig: 0,
    mean_share_ig: 0,
    mean_watch_fb: 0,
    mean_like_fb: 0,
    mean_comment_ig: 0,
    mean_comment_yt: 0,
    radar_newatt_val: 0,
    mean_share_fb: 0,
    radar_avefoc_val: 0,
    mean_watch_ig: 0,
    emofoc_val: 0,
    ai_teacher_advice: '',
    count_fans: 0,
    mean_touch_yt: 0,
    avefoc_val: 0,
    mean_touch_ig: 0,
    mean_watch_yt: 0,
    count_fb: 0,
  })

  // 拿到公司列表
  useEffect(() => {
    setIsLoading(true)
    axios
      .get(BaseUrl + getSubIncorporation, {
        headers: {
          'Content-Type': 'text/plain; charset=UTF-8',
          Accept: '*/*',
          tk: currentUser.tk,
        },
      })
      .then((res) => {
        // console.log('power getSubIncorporation data', res.data.data)
        setCompanyName(res.data.data)
        setIsLoading(false)
      })
      .catch((e) => {
        setIsLoading(false)
        console.log(e)
      })
  }, [])

  // 拿到全公司資料
  const allCompanyRequestBody = { date: today }
  const fetchAllCompanyData = useAPI({
    path: getIncLast,
    requestBody: allCompanyRequestBody,
    initData: incLastData,
    msg: '天神綜合分析',
    dependencies: [currentCompanyId],
  }).fetchData

  useEffect(() => {
    if (fetchAllCompanyData.data) {
      setIncLastData(fetchAllCompanyData.data)
    }
    // console.log('fetchAllCompanyData', fetchAllCompanyData)
  }, [fetchAllCompanyData])

  const [totalFBFanCount, setTotalFBFanCount] = useState(0)
  const [totalIGFanCount, setTotalIGFanCount] = useState(0)
  const [totalYTFanCount, setTotalYTFanCount] = useState(0)
  useEffect(() => {
    setTotalFBFanCount(
      incLastData.reduce((total, element) => total + element.count_fb, 0)
    )
    setTotalIGFanCount(
      incLastData.reduce((total, element) => total + element.count_ig, 0)
    )
    setTotalYTFanCount(
      incLastData.reduce((total, element) => total + element.count_yt, 0)
    )
  }, [incLastData])

  // 取得單一公司資料
  const requestBody = { kol_id: currentCompanyId }
  const fetchCurrentCompanyData = useAPI({
    path: getLast,
    requestBody: requestBody,
    initData: currentCompanyData,
    msg: '天神單一公司綜合分析',
    dependencies: [currentCompanyId, currentCompany],
  }).fetchData

  useEffect(() => {
    if (currentCompany) {
      setCurrentCompanyData(fetchCurrentCompanyData)
      // console.log('fetchCurrentCompanyData', fetchCurrentCompanyData)
    }
  }, [fetchCurrentCompanyData])

  // 當前查看的公司
  useEffect(() => {
    incLastData.forEach((element) => {
      if (currentCompanyId === element.kol_id) {
        setCurrentCompany(element)
      } else if (currentCompanyId === null) {
        setCurrentCompany(null)
      }
    })
  }, [currentCompanyId])

  const [doughnutOption, setDoughnutOption] = useState({})

  // 當前查看的公司
  useEffect(() => {
    setDoughnutOption({
      tooltip: {
        trigger: 'item',
        formatter: '{b} {c} (人)',
      },
      legend: {
        top: 'bottom',
        left: 'center',
      },
      series: [
        {
          name: '粉絲數量分布',
          type: 'pie',
          radius: ['40%', '70%'],
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: 'center',
          },
          itemStyle: {
            borderRadius: 5,
            borderColor: '#fff',
            borderWidth: 3,
          },
          emphasis: {
            label: {
              show: false,
              fontSize: 10,
              fontWeight: 'bold',
            },
          },
          labelLine: {
            show: false,
          },
          data: [
            {
              value: !currentCompanyId
                ? totalFBFanCount
                : typeof currentCompanyData.count_fb === 'number'
                ? currentCompanyData.count_fb
                : 0,
              name: 'Facebook',
            },
            {
              value: !currentCompanyId
                ? totalIGFanCount
                : typeof currentCompanyData.count_ig === 'number'
                ? currentCompanyData.count_ig
                : 0,
              name: 'Instagram',
            },
            {
              value: !currentCompanyId
                ? totalYTFanCount
                : typeof currentCompanyData.count_yt === 'number'
                ? currentCompanyData.count_yt
                : 0,
              name: 'YouTube',
            },
          ],
          color: ['#4267B2', '#C13584', '#FF0000'],
        },
      ],
    })
  }, [
    currentCompanyId,
    currentCompanyData,
    totalFBFanCount,
    totalIGFanCount,
    totalYTFanCount,
  ])

  return (
    <div>
      <Helmet>
        <title>綜合分析 | KOLSTAR</title>
      </Helmet>
      <main className="groupPower d-flex flex-column flex-md-row">
        <Col xs={12} md={3} className="d-flex flex-column sideBar">
          <GroupSideBar
            companyName={companyName}
            setCurrentCompanyId={setCurrentCompanyId}
            currentCompanyId={currentCompanyId}
          />
        </Col>
        {/* 全品牌 */}
        {!currentCompanyId && (
          <Col xs={12} md={9}>
            <Container className="section1">
              <Row className="d-flex flex-column-reverse flex-xl-row">
                <Col
                  xs={12}
                  xl={5}
                  className="flex-grow-1 text-nowrap overflowX mt-auto"
                >
                  <GroupPowerFans
                    incLastData={incLastData}
                    csvDate={csvDate}
                    csvData={csvData}
                  />
                </Col>
                <Col xl={4} className="mx-xl-3 px-xl-3 order-md-1 m-auto">
                  <ReactEcharts
                    style={{ width: '100%', height: '300px' }}
                    className="w-100"
                    option={doughnutOption}
                  />
                </Col>
              </Row>
            </Container>
            <Container className="section2">
              <GroupComprehensive
                incLastData={incLastData}
                setIncLastData={setIncLastData}
                currentUser={currentUser}
                setCsvDate={setCsvDate}
                setCsvData={setCsvData}
                setIsLoading={setIsLoading}
                title="個別品牌綜合分析"
              />
            </Container>
          </Col>
        )}
        {/* =============================== 各品牌 =============================== */}
        {currentCompany && (
          <Col xs={12} md={9}>
            <Container className="section1">
              <h3 className="fw-bold mt-4 mx-3 d-md-none">
                {currentCompany.kol_name}
              </h3>

              <Row className="d-flex flex-column-reverse flex-md-row mx-2">
                <Col
                  xs={12}
                  md={5}
                  className="flex-grow-1 text-nowrap overflowX mt-auto"
                >
                  <h3 className="fw-bold mt-4 d-none d-md-block">
                    {currentCompany.kol_name}
                  </h3>

                  <PowerFans data={currentCompanyData} />
                </Col>
                <Col md={4} className="mx-lg-3 px-lg-3 order-md-1 m-auto">
                  <ReactEcharts
                    style={{ width: '100%', height: '300px' }}
                    className="w-100"
                    option={doughnutOption}
                  />
                </Col>
              </Row>
            </Container>
            <Container className="section2">
              <Row className="mx-2">
                <Interaction
                  data={currentCompanyData}
                  title="經營互動指標"
                  brandArr={brandArr}
                />
              </Row>
            </Container>
            <Container className="section3">
              <Row className="mx-2">
                <PowerScan data={currentCompanyData} title="戰力掃描" />
              </Row>
            </Container>
            <Container className="section4">
              <Row className="mx-2">
                <AITeacher data={currentCompanyData} title="AI 導師建議" />
              </Row>
            </Container>
            <Container className="section5">
              <Row className="mx-2">
                <Radar data={currentCompanyData} title="優勢雷達圖" />
              </Row>
            </Container>
            <Container className="section6">
              <Row className="mx-2">
                <TrendTracking
                  title="戰力趨勢追蹤"
                  currentCompanyId={currentCompanyId}
                />
              </Row>
            </Container>
          </Col>
        )}
      </main>
    </div>
  )
}

export default GroupPower
